import React, { useState, useRef, useEffect } from 'react';

interface LineNumberedTextAreaProps {
  value: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
  placeholder?: string;
}

export const LineNumberedTextArea: React.FC<LineNumberedTextAreaProps> = ({
  value,
  onChange,
  placeholder
}) => {
  const [lineCount, setLineCount] = useState(1);
  const textareaRef = useRef<HTMLTextAreaElement>(null);
  const lineNumbersRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    updateLineCount();
  }, [value]);

  const updateLineCount = () => {
    const lines = (value.match(/\n/g) || []).length + 1;
    setLineCount(lines);
  };

  const handleScroll = () => {
    if (lineNumbersRef.current && textareaRef.current) {
      lineNumbersRef.current.style.transform = `translateY(-${textareaRef.current.scrollTop}px)`;
    }
  };

  const lineNumbers = Array.from({ length: lineCount }, (_, i) => (
    <div key={i + 1} className="line-number">{i + 1}</div>
  ));

  return (
    <div className="absolute inset-0">
      <div className="absolute left-0 top-0 bottom-0 w-[40px] sm:w-[50px] bg-editor-dark border-r border-editor-border z-10">
        <div ref={lineNumbersRef} className="absolute top-0 left-0 w-full py-2 font-mono text-xs sm:text-sm text-editor-line text-right select-none">
          {lineNumbers}
        </div>
      </div>
      <textarea
        autoFocus
        ref={textareaRef}
        value={value}
        onChange={onChange}
        onScroll={handleScroll}
        placeholder={placeholder}
        spellCheck={false}
        className="absolute inset-0 py-2 pl-[45px] sm:pl-[58px] pr-2 bg-transparent border-none text-editor-text font-mono text-xs sm:text-sm leading-5 resize-none outline-none"
      />
    </div>
  );
};

export default LineNumberedTextArea;
